import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 住所
 */
export class Address extends PrimitiveValueObject<string> {
  /**
   * 作成
   * @param value 値
   * @returns 値
   */
  static create(value: string): Address {
    if (value.length > this.validationRule.max.value) {
      throw new Error(this.validationRule.max.message);
    }
    return new Address(value);
  }

  /**
   * ラベル
   */
  static get label(): string {
    return '住所';
  }

  /**
   * プレースホルダー
   */
  static get placeholder(): string {
    return '東京都千代田区千代田1-1 アパート101号室';
  }

  /**
   * タイプ
   */
  static get type() {
    return 'text';
  }

  /**
   * キー
   */
  static get key() {
    return 'address';
  }

  /**
   * バリデーションルール
   */
  static get validationRule() {
    return {
      /** 必須項目 */
      required: '必須項目です',
      /** 最大 */
      max: {
        /** 値 */
        value: 256,
        /** メッセージ */
        message: '256文字以下にしてください',
      },
    };
  }
}
